import { useDispatch, useSelector } from 'react-redux';
import { Switch } from '@mui/material';
import { featureFlags } from 'src/config/featureFlags';
import { selectDeleteMode, setDeleteMode } from 'src/infra/stores/reducer/deleteModeSlice';
import React from 'react';

export const DeleteModeSwitch = () => {
  const dispatch = useDispatch();
  const enable = useSelector(selectDeleteMode);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(setDeleteMode(event.target.checked));
    window.location.reload();
  };

  if (!featureFlags.DELETE_MODE_SWITCH) {
    return null;
  }

  return (
    <div className='flex items-center justify-between p-8 bg-neutral-10 border border-neutral-20 rounded-8'>
      <div className='flex flex-col'>
        <p className='text-12 font-medium text-neutral-60 text-left'>Delete Mode</p>
      </div>
      <Switch checked={enable} onChange={handleChange} color='primary' size='small' inputProps={{ 'aria-label': 'toggle Delete Mode' }} />
    </div>
  );
};
